var map = {
	"./ageLimit.svg": 72255,
	"./alertBell.svg": 39262,
	"./beGambleAware.svg": 35336,
	"./binocularsSelected.svg": 46296,
	"./binocularsSquare.svg": 45254,
	"./binocularsUnselected.svg": 39253,
	"./breakReturn.svg": 41372,
	"./calendar.svg": 39463,
	"./calendarCircled.svg": 68221,
	"./channelOption.svg": 11681,
	"./chevronBoldDown.svg": 4111,
	"./chevronBoldRight.svg": 70271,
	"./chevronBoldRightWhite.svg": 5186,
	"./chevronBoldUp.svg": 45632,
	"./chevronDownCircled.svg": 77790,
	"./chevronLeft.svg": 87645,
	"./chevronLightRight.svg": 364,
	"./chevronPinkLeft.svg": 65073,
	"./chevronRight.svg": 62272,
	"./chevronRightSmall.svg": 38661,
	"./close.svg": 30783,
	"./closeCircled.svg": 46117,
	"./cloudy.svg": 96237,
	"./cloudy_windy.svg": 74303,
	"./clubDay.svg": 19673,
	"./cog.svg": 25998,
	"./cold.svg": 93859,
	"./courseNegative.svg": 98487,
	"./coursePositive.svg": 94747,
	"./cross.svg": 78647,
	"./enterFullScreen.svg": 37270,
	"./exitFullScreen.svg": 56898,
	"./eye.svg": 96336,
	"./facebookDark.svg": 94377,
	"./facebookLight.svg": 38687,
	"./filter.svg": 7219,
	"./flag_ae.svg": 2764,
	"./flag_au.svg": 61148,
	"./flag_bh.svg": 76704,
	"./flag_ca.svg": 95626,
	"./flag_de.svg": 17927,
	"./flag_fr.svg": 942,
	"./flag_gb.svg": 39917,
	"./flag_ie.svg": 60836,
	"./flag_jp.svg": 21024,
	"./flag_sa.svg": 90746,
	"./flag_se.svg": 89446,
	"./flag_sg.svg": 47652,
	"./flag_us.svg": 68198,
	"./flag_za.svg": 38097,
	"./freeBetPlaceholder.svg": 11211,
	"./gamCare.svg": 42681,
	"./gamStop.svg": 29734,
	"./gordonMoody.svg": 85728,
	"./handicapDebut.svg": 72805,
	"./hat.svg": 38168,
	"./headgearFirst.svg": 71148,
	"./home.svg": 60820,
	"./homeSelected.svg": 60951,
	"./horseInFocus.svg": 62267,
	"./info.svg": 4649,
	"./infoPink.svg": 48457,
	"./instagramDark.svg": 99091,
	"./instagramLight.svg": 27481,
	"./lock.svg": 90104,
	"./logoLong.svg": 20922,
	"./logoSquare.svg": 71693,
	"./longLogo.svg": 20586,
	"./menu.svg": 61520,
	"./menuSelected.svg": 25683,
	"./minus.svg": 99151,
	"./mutedVolume.svg": 57480,
	"./notification.svg": 47616,
	"./notificationBadge.svg": 86073,
	"./notificationSelected.svg": 80707,
	"./notificationUnselected.svg": 48478,
	"./oddscheckerLogo.svg": 13829,
	"./partly_cloudy.svg": 62326,
	"./pauseVideo.svg": 65566,
	"./pencil.svg": 10642,
	"./person.svg": 75710,
	"./play.svg": 61927,
	"./playCircled.svg": 55101,
	"./playCircledUnavailable.svg": 11913,
	"./playHead.svg": 37753,
	"./playVideo.svg": 99140,
	"./plug.svg": 24301,
	"./plus.svg": 21025,
	"./popout.svg": 39586,
	"./profile.svg": 57360,
	"./rLogo.svg": 51784,
	"./raceIqInfo.svg": 64668,
	"./raceIqLogoTeal.svg": 52211,
	"./races.svg": 72321,
	"./racesSelected.svg": 73998,
	"./radial.svg": 71236,
	"./rainy.svg": 57340,
	"./rainy_windy.svg": 33098,
	"./results.svg": 59165,
	"./resultsSelected.svg": 58042,
	"./rtvLogo.svg": 17150,
	"./saferGamblingStandard.svg": 64182,
	"./scottishSeason.svg": 61881,
	"./scrollDOwn.svg": 514,
	"./search.svg": 38141,
	"./searchBorderlessPink.svg": 45232,
	"./sectionalTiming.svg": 58507,
	"./settingWheel.svg": 524,
	"./share.svg": 39730,
	"./silkDefault.svg": 2113,
	"./sireCourseStrikeRate.svg": 56841,
	"./sireDistanceStrikeRate.svg": 30591,
	"./sireGoingStrikeRate.svg": 61844,
	"./smallLogo.svg": 17675,
	"./snowy.svg": 54669,
	"./sort.svg": 29253,
	"./stopWatch.svg": 74682,
	"./sunny.svg": 72738,
	"./sunny_windy.svg": 65724,
	"./tick.svg": 18666,
	"./tiktokDark.svg": 13739,
	"./tiktokLight.svg": 86241,
	"./timeform.svg": 37912,
	"./tips.svg": 93723,
	"./tipsSelected.svg": 60496,
	"./trainerInForm.svg": 44987,
	"./trainerOutOfForm.svg": 56969,
	"./twitterDark.svg": 75138,
	"./twitterLight.svg": 81562,
	"./uplift.svg": 7681,
	"./volume.svg": 12755,
	"./warning.svg": 22291,
	"./warningHorse.svg": 74574,
	"./watch.svg": 49522,
	"./watchSelected.svg": 3293,
	"./weekend.svg": 82756,
	"./wind.svg": 42563,
	"./youtubeDark.svg": 49744,
	"./youtubeLight.svg": 14112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98178;